var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-group',{ref:"group",attrs:{"config":_vm.group},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('app-circle',{attrs:{"config":_vm.circle,"anchor":"center"}}),_c('app-image',{attrs:{"config":_vm.image,"anchor":"center"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }